import React, { useState, useContext, useEffect } from 'react'
import { Input, Button, Result } from 'antd'
import { useTranslation } from 'react-i18next'
import { MdOutlineMarkEmailRead } from 'react-icons/md'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { useMutation } from 'react-query'
import validateEmail from 'validator/lib/isEmail'
import isMobilePhone from 'validator/lib/isMobilePhone'

import { FeathersContext } from '../../../../services/feathers'

import * as s from './CreateTalentForm.styles'

const CreateTalentForm = () => {
  const feathers = useContext(FeathersContext)
  const talent = useSelector((state) => state.talent)

  const { t } = useTranslation(['common', 'talentArea'], {
    useSuspense: false,
  })
  const [firstname, setFirstname] = useState('')
  const [lastname, setLastname] = useState('')
  const [email, setEmail] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [isEmail, setIsEmail] = useState(false)
  const [isValidPhone, setIsValidPhone] = useState(false)
  const [messageSent, setMessageSent] = useState(false)

  const query = new URLSearchParams(useLocation().search)
  const poolId = query.get('join')

  useEffect(() => {
    setIsValidPhone(isMobilePhone(phoneNumber))
  }, [phoneNumber])

  const onEmailValueChange = (e) => {
    setEmail(e.target.value)
    setIsEmail(validateEmail(e.target.value))
  }

  const handleCreateTalent = useMutation(
    async () => {
      await feathers.service('lambda-talent').create({
        query: {
          firstname,
          lastname,
          email,
          phoneNumber,
          companyId: talent.company.id,
          ...(poolId ? { candidatePool_id: poolId } : {}),
        },
        action: 'createCandidate',
      })

      setMessageSent(true)
    },
    {
      onError: (error) => {
        console.error(error)
      },
    },
  )

  if (messageSent) {
    return (
      <div data-cy="submit-community-success">
        <Result
          status="success"
          icon={<MdOutlineMarkEmailRead size={40} color="#02CD9A" />}
          title={t('talentArea:company.messageSent.title')}
          subTitle={t('talentArea:company.messageSent.title')}
        />
      </div>
    )
  }

  return (
    <s.CreateTalentFormWrapper>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <div className="field-wrapper" style={{ width: '50%' }}>
          <label htmlFor="firstname">{t('common:firstname')}</label>
          <Input
            placeholder={t('common:firstname')}
            type="text"
            name="firstname"
            id="firstname"
            autoComplete="off"
            value={firstname}
            onChange={(e) => setFirstname(e.target.value)}
          />
        </div>
        <div className="field-wrapper" style={{ width: '50%' }}>
          <label htmlFor="lastname">{t('common:lastname')}</label>
          <Input
            type="text"
            placeholder={t('common:lastname')}
            name="lastname"
            id="lastname"
            autoComplete="off"
            value={lastname}
            onChange={(e) => setLastname(e.target.value)}
          />
        </div>
      </div>
      <div className="field-wrapper">
        <label htmlFor="email">{t('common:email')}</label>
        <Input
          placeholder={t('common:email')}
          type="email"
          name="email"
          id="email"
          autoComplete="off"
          value={email}
          onChange={onEmailValueChange}
        />
      </div>
      <div className="field-wrapper">
        <label htmlFor="phoneNumber">{t('common:phone')}</label>
        <Input
          type="number"
          id="phoneNumber"
          placeholder={t('common:phone')}
          name="phoneNumber"
          value={phoneNumber}
          autoComplete="off"
          onChange={(e) => setPhoneNumber(e.target.value)}
        />
      </div>
      <Button
        className="basic-btn"
        onClick={handleCreateTalent.mutate}
        disabled={!isEmail || !isValidPhone}
        data-cy="submit-community-form"
      >
        {t('talentArea:company.joinBtn')}
      </Button>
    </s.CreateTalentFormWrapper>
  )
}

export default CreateTalentForm
